import { Img } from "../Img";
import { Button } from "../Button";
import React from "react";
import FormInput from "../FormInput";

export function PaymentOptions({ formData, setFormData, setErrors, errors, validateFormData }) {
  return (
    <>
      <div
        className="bg-white-A700 flex md:flex-1 flex-col border items-start justify-start p-2.5 rounded-lg w-[67%] md:w-full">
        <div className="w-[80px] h-auto cursor-pointer">
          <Img alt="Tigopesa" className="object-cover" src="/images/tigopesa.png" />
        </div>
        <FormInput
          value={formData?.mobile}
          onChange={(value) => {
            setFormData(p => ({ ...p, mobile: value }));
            setErrors(p => ({ ...p, mobile: [] }));
          }}
          errors={errors?.mobile}
          type={"number"}
          className="flex flex-col gap-[7px] items-start justify-start mt-6 w-full"
          placeholder="Enter number"
          label="Tigo-pesa mobile number for payment"
        />
        <Button
          onClick={validateFormData}
          className="cursor-pointer flex items-center justify-center mb-9 min-w-[178px] mt-4 rounded-[20px]"
          leftIcon={
            <Img
              className="mr-[13px]"
              src="images/img_payment_white_a700.svg"
              alt="Payment"
            />
          }
          shape="circle"
          color="indigo_A700"
          size="xs"
          variant="fill"
        >
          <div className="!text-white-A700 text-left text-sm tracking-[0.25px]">
            PAY
          </div>
        </Button>
      </div>
    </>
  );
}